export var SystemDisplayState;
(function (SystemDisplayState) {
    SystemDisplayState["fault"] = "fault";
    SystemDisplayState["warning"] = "warning";
    SystemDisplayState["unknown"] = "unknown";
    SystemDisplayState["disabled"] = "disabled";
    SystemDisplayState["standby"] = "standby";
    SystemDisplayState["enabled"] = "enabled";
})(SystemDisplayState || (SystemDisplayState = {}));
export var IndicatorTier;
(function (IndicatorTier) {
    IndicatorTier[IndicatorTier["one"] = 1] = "one";
    IndicatorTier[IndicatorTier["two"] = 2] = "two";
    IndicatorTier[IndicatorTier["three"] = 3] = "three";
    IndicatorTier[IndicatorTier["four"] = 4] = "four";
    IndicatorTier[IndicatorTier["five"] = 5] = "five";
    IndicatorTier[IndicatorTier["six"] = 6] = "six";
    IndicatorTier[IndicatorTier["seven"] = 7] = "seven";
    IndicatorTier[IndicatorTier["eight"] = 8] = "eight";
    IndicatorTier[IndicatorTier["nine"] = 9] = "nine";
    IndicatorTier[IndicatorTier["ten"] = 10] = "ten";
})(IndicatorTier || (IndicatorTier = {}));
//# sourceMappingURL=index.types.js.map